import { createContext, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api, setToken, clearToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [booting, setBooting] = useState(true);
  const qc = useQueryClient();

  useEffect(() => {
    (async () => {
      if (getToken()) {
        try {
          setMe(await api.get("/me"));
        } catch {
          clearToken();
        }
      }
      setBooting(false);
    })();
  }, []);

  const signIn = async (email, password) => {
    qc.clear();
    const r = await api.post("/auth/admin/login", { email, password });
    setToken(r.access_token);
    setMe(await api.get("/me"));
    return r;
  };

  const startSession = async (token) => {
    qc.clear();
    setToken(token);
    setMe(await api.get("/me"));
  };

  const signOut = () => {
    clearToken();
    setMe(null);
    qc.clear();
  };

  return (
    <AuthContext.Provider value={{ me, booting, signIn, startSession, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
